import React, { useMemo } from 'react'

export const QuestionnaireSection = () => {
  const descriptions = useMemo(
    () => [
      ':: Updated, modern interface for faster processing',
      ':: Status history with timestamps of milestones',
      ':: Full-screen form preview',
    ],
    []
  )

  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      <div className="dome-d-flex dome-flex-column dome-relative">
        <div className="questionnaire-beacon-introducing">introducing</div>
        <div className="questionnaire-beacon-title">
          <span className="dome-h2 dome-color-green-gradient">questionnaires</span>
        </div>
      </div>
      <div className="questionnaire-beacon-content dome-d-flex dome-flex-column dome-gap6">
        <span className="dome-p2 dome-color-darkest-grey">New look, better tech— with more to come!</span>
        <ul className="dome-list-no-style dome-d-flex dome-flex-column">
          {descriptions.map((item) => (
            <li key={item} className="dome-p3 dome-color-med-grey">
              {item}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export const FormSection = () => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      <span className="dome-h2 dome-color-green-gradient">the form</span>
      <div className="questionnaire-beacon-content">
        <span className="dome-p2 dome-color-dark-grey">
          You’ll see a blank questionnaire form on the left side of the screen. When you upload the completed
          questionnaire, the view will update to reflect that.
        </span>
      </div>
    </div>
  )
}

export const TaskSection = () => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      <span className="dome-h2 dome-color-green-gradient">the task</span>
      <div className="questionnaire-beacon-content">
        <span className="dome-p2 dome-color-dark-grey">
          On the right side of the screen, find building + requester information with status. Use the tools to set
          price, upload completed forms, and send the final questionnaire.
        </span>
      </div>
    </div>
  )
}

export const FutureSection = () => {
  return (
    <div className="dome-d-flex dome-flex-column dome-gap12">
      <span className="dome-h2 dome-color-green-gradient">the future</span>
      <div className="questionnaire-beacon-content dome-d-flex dome-flex-column">
        <span className="dome-p2 dome-color-dark-grey">Stay tuned...</span>
        <span className="dome-p2 dome-color-dark-grey">
          We’re building a way to create forms that make your workflow more efficient!
        </span>
      </div>
    </div>
  )
}
